import RepositoryFactory from "../../admin/apis/index";
const order = RepositoryFactory.ecomOrder;

export default {
  addOrder({}, payload) {
    return new Promise(async (resolve, reject) => {
      try {
        // console.log("api called");
        const { data } = await order.addOrder(payload);
        resolve(data);
      } catch (error) {
        console.log(error);
        reject(error);
      }
    });
  },
  updateOrder({}, payload) {
    return new Promise(async (resolve, reject) => {
      try {
        // console.log("api called");
        const { data } = await order.updateOrder(payload);
        resolve(data);
      } catch (error) {
        console.log(error);
        reject(error);
      }
    });
  },
  getOrder({ commit }, payload) {
    return new Promise(async (resolve, reject) => {
      try {
        console.log("api called");
        const { data } = await order.getOrder(payload);

        commit("SET_ORDER", data.data.result);
        resolve(data);
      } catch (error) {
        console.log(error);
        reject(error);
      }
    });
  },
  getOrderByUserId({ commit }) {
    return new Promise(async (resolve, reject) => {
      try {
        console.log("api called");
        const { data } = await order.getOrderByUserId();

        commit("SET_ORDER", data.data.result);
        resolve(data);
      } catch (error) {
        console.log(error);
        reject(error);
      }
    });
  },
  productImage({}, payload) {
    return new Promise(async (resolve, reject) => {
      try {
        console.log("api called");
        const { data } = await order.productImage(payload);
        resolve(data);
      } catch (error) {
        console.log(error);
        reject(error);
      }
    });
  },
};
